<!--  -->
<template>
  <div class='preference-container' ref="preferenceRef">
    <div class="preference-card" v-loading="loading">
      <!-- 标题部分 -->
      <div class="preference-header">
        <h2>个人偏好</h2>
      </div>
      
      <!-- 说明文字 -->
      <div class="preference-description">
        <p class="preference-title" style="margin: 2.5rem 0;">您希望通过下列哪种方式获取香奈儿相关资讯?</p>
        <el-checkbox v-model="brandConsent" class="brand-consent">
          我希望香奈儿（中国）贸易有限公司和香奈儿组织通过电子邮件、电话、短信、即时通讯和邮寄向我发送有关新序列、产品、服务和活动的品牌信息。
        </el-checkbox>
      </div>
      
      <!-- 个人偏好部分 -->
      <div class="preference-section">
        <h3>个人偏好</h3>
        <el-divider></el-divider>
        <div class="preference-options">
          <p class="preference-title">我希望接收关于以下内容的通讯：</p>
          <div class="checkbox-group">
            <el-checkbox v-model="preferences.luxury" class="luxury">腕表和高级珠宝</el-checkbox>
            <el-checkbox v-model="preferences.perfume" class="perfume">香水和美妆</el-checkbox>
            <el-checkbox v-model="preferences.special" class="special">精品</el-checkbox>
          </div>
        </div>
      </div>
      
      <!-- 通讯渠道部分 -->
      <div class="preference-section">
        <h3>通讯渠道</h3>
        <el-divider></el-divider>
        <div class="preference-options">
          <p class="preference-title">我希望通过以下方式收到CHANEL的资讯：</p>
          <div class="communication-channels">
            <div class="channel-row">
              <el-checkbox v-model="channels.email" class="email">电子邮件</el-checkbox>
              <el-checkbox v-model="channels.paper" class="paper">纸质信件</el-checkbox>
            </div>
            <div class="channel-row">
              <el-checkbox v-model="channels.sms" class="sms">短信</el-checkbox>
              <el-checkbox v-model="channels.phone" class="phone">电话</el-checkbox>
            </div>
            <div class="channel-row">
              <el-checkbox v-model="channels.wechat" class="wechat">微信</el-checkbox>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 按钮部分 -->
      <div class="preference-button">
        <el-button type="primary" @click="submit" block>更新偏好设置</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { setRemSize } from '@/utils/common'
export default {
  components: {},
  data() {
    return {
      loading: false,
      brandConsent:false,
      preferences: {
        luxury: false,
        perfume: false,
        special: false
      },
      channels: {
        email: false,
        paper: false,
        sms: false,
        phone: false,
        wechat: false
      },
      messageHandler: null, // 用于存储事件处理函数
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.setRemSize();
    // 添加窗口大小变化的监听器
    window.addEventListener('resize', this.setRemSize);
    console.log('router.query', this.$route.query)
    const code = this.$route.query.code;
    if(code){
      this.getConSent(code);
    }
    this.onMessage('getPreferenceData', () => {
      this.sendMessage('sendPreferenceData',{
        brandConsent:this.brandConsent,
        preferences: this.preferences,
        channels: this.channels
      })
    });
  },
  methods: {
    setRemSize,
    getConSent(code){
      this.loading = true;
      axios.post(`${process.env.VUE_APP_CPC_API}/cpc/v1/getConsent`, {
        code,
      })
        .then(res => {
          if (res.data?.success && res.data?.object) {
            const data = res.data.object;
            this.brandConsent = data.privacyConsent==='1'?true:false;
            this.preferences = {
              luxury: data.marketingConsent==='1'?true:false,
              perfume: false,
              special: false
            };
            this.channels = {
              email: data.emailConsent==='1'?true:false,
              paper: false,
              sms: data.smsConsent==='1'?true:false,
              phone: false,
              wechat: false
            };
          }
        }).finally(() => {
          this.loading = false;
        });
    },
    submit(){
      // 发送数据到父窗口
     this.sendMessage('sendPreferenceData',{
      brandConsent:this.brandConsent,
        preferences: this.preferences,
        channels: this.channels
      })
    },
    getEnv() {
      if (window.Android) return 'android';
      if (window.webkit && window.webkit.messageHandlers) return 'ios';
      if (window.__wxjs_environment === 'miniprogram') return 'miniprogram';
      if (window.parent !== window) return 'web-iframe';
      return 'web';
    },
    sendMessage(msgName, data) {
      const env = this.getEnv();
      console.log('%c  env ===>', 'font-size:13px; background:pink; color:#bf2c9f;', env)
      const payload = { msgName, data };
      console.log('%c  payload ===>', 'font-size:13px; background:pink; color:#bf2c9f;', payload)
      if (env === 'android') {
        window.Android.messageBridge(JSON.stringify(payload));
      } else if (env === 'ios') {
        window.webkit.messageHandlers.messageBridge.postMessage(payload);
      } else if (env === 'miniprogram') {
        // 小程序web-view
        if (window.wx) {
          window.wx.miniProgram.postMessage(payload);
        }
      } else if (env === 'web-iframe') {
        window.parent.postMessage(payload, '*');
      } else {
        // 普通web
        console.log('当前为web环境，未嵌套');
      }
    },
    onMessage(type, callback) {
      const env = this.getEnv();
      if (env === 'android' || env === 'ios') {
        // 原生App一般通过注入全局方法回调
        // 需要ios:webView.evaluateJavaScript("window.onNativeMessage({type: 'getPreferenceData', data: {}})", completionHandler: nil)
        // 需要android:webView.evaluateJavascript("window.onNativeMessage({type: 'getPreferenceData', data: {}})", null);
        window.onNativeMessage = function(payload) {
          if (payload.type === type) callback(payload.data);
        };
      } else {
        this.messageHandler = (e) => {
          if (e.data && e.data.type === type) {
            callback(e.data.data);
          }
        };
        window.addEventListener('message', this.messageHandler);
      }
    }
  },
  beforeDestroy() {
    // 移除事件监听器以防止内存泄漏
    window.removeEventListener('resize', this.setRemSize);
    if (this.messageHandler) {
      window.removeEventListener('message', this.messageHandler);
    }
    // 清空原生消息处理器
    if (window.onNativeMessage) {
      window.onNativeMessage = null;
    }
  },
}
</script>

<style lang='scss' scoped>
/* 设置rem基础单位 */
html {
  font-size: 16px;
}

/* 根据屏幕大小调整基础font-size */
// @media (max-width: 1024px) {
//   html {
//     font-size: 15px;
//   }
// }

// @media (max-width: 768px) {
//   html {
//     font-size: 14px;
//   }
// }

// @media (max-width: 480px) {
//   html {
//     font-size: 12px;
//   }
// }

.preference-container {
  height: calc(100% - 2rem);
  display: flex;
  justify-content: center;
  // align-items: center;
  padding: 1rem;
  background-color: #f5f5f5;
  font-family: Arial, sans-serif;
}

.preference-card {
  width: 100%;
  height: calc(100% - 2.5rem);
  overflow-y: auto;
  // max-width: 36rem;
  background: white;
  border: 0.05rem solid #e0e0e0;
  border-radius: 0.25rem;
  padding: 1.25rem;
  margin: 0 auto;
  box-shadow: 0 0.125rem 0.75rem 0 rgba(0, 0, 0, 0.1);
  /deep/ .el-checkbox{
    .el-checkbox__input .el-checkbox__inner{
      width: 1.2rem;
      height: 1.2rem;
      &::after{
        width: 0.3rem;
        height: 0.6rem;
        top: 0.1rem;
        left: 0.35rem;
      }
    }
    .el-checkbox__label{
      font-size: 1.2rem;
      line-height: 1.8rem;
      padding-left: 1rem;
    }
  }
}

.preference-title{
  font-size: 1.2rem;
}

.preference-header {
  margin-bottom: 1.25rem;
  
  h2 {
    font-size: 1.8rem;
    font-weight: bold;
    margin: 0;
    text-align: center;
  }
}

.preference-description {
  margin-bottom: 1.6rem;
  
  p {
    margin: 0 0 0.5rem 0;
    line-height: 1.5;
  }

  /deep/ .el-checkbox{
    display: flex;
    align-items: center;
    .el-checkbox__label{
      white-space: normal;
    }
  }
}

.preference-section {
  margin-bottom: 1.6rem;
  
  h3 {
    font-size: 1.25rem;
    font-weight: bold;
    margin: 0 0 0.5rem 0;
  }
  
  p {
    margin-bottom: 1rem;
  }
  .el-divider--horizontal{
    margin: 1.4rem 0;
    height: 0.05rem;
  }
}

.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.communication-channels {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.channel-row {
  display: flex;
  gap: 1.25rem;

  /deep/ .el-checkbox{
    width: 10rem;
  }
}

.preference-button {
  margin-top: 2rem;
  margin-bottom: 2rem;
  text-align: center;
  padding: 0 1rem;
  
  .el-button {
    height: 2.6rem;
    line-height: 2.6rem;
    font-size: 1rem;
    padding: 0;
    background-color: #000;
    border-color: #000;
    width: 100%;
    max-width: 35rem;
  }
}
</style>